import { useMemo } from "react";
import { placeLabelToUrl } from "@hopper-b2b/lodging-utils";

export function useLodgingLink(id?: string, name?: string) {
  const search = window.location.search;
  const queryParams = search.startsWith("?") ? search.slice(1) : search;

  return useMemo(() => {
    const urlFriendlyName = placeLabelToUrl(name);

    return `/hotels/shop/${urlFriendlyName}/${id}?${queryParams}`;
  }, [id, name, queryParams]);
}
